// extracted by mini-css-extract-plugin
module.exports = {"action":"paymentYearColumn_action__2qBoC","modal":"paymentYearColumn_modal__2ChqR","modalTitle":"paymentYearColumn_modalTitle__3XxpB","input":"paymentYearColumn_input__mdC85"};